/** One turn of .trace-auth-spinner: its animation duration in styles/trace-auth.css. */
export const SPINNER_TURN_MS = 800;
/**
 * The animation-delay that puts a spinner created now at the wall clock's phase, so every spinner is at the same angle
 * at the same moment: the static index.html shell, the React screen that replaces it, and the next page of a sign-in
 * (a full page load on another origin) all continue one rotation instead of each starting again from the top, which
 * read as a flicker on every hop (Noam, 2026-10-28). The static shell (vite/signing-in-shell.cjs) does the same.
 */
export function spinnerPhaseDelay(now = Date.now()) {
    return `${-(now % SPINNER_TURN_MS)}ms`;
}
//# sourceMappingURL=spinner.js.map